import {action, observable} from 'mobx';
import BaseStore from "./Base.store";
import moment from 'moment';

export default class RelatorioStore extends BaseStore {

  @observable configuracaoUnidade = null;

  @action verificaLimiteTresMeses = (dataInicial, dataFinal) => {
    const dataInicialMoment = moment(dataInicial);
    const dataFinalMoment = moment(dataFinal);

    if (!dataInicialMoment.isValid() || !dataFinalMoment.isValid()) {
      return false;
    }

    const limite = dataInicialMoment.clone().add(3, 'months');
    return dataFinalMoment.isSameOrBefore(limite, 'day');
  };

  @action verificarIntervaloDatas = (dataInicial, dataFinal) => {
    const dataInicialMoment = moment(dataInicial);
    const dataFinalMoment = moment(dataFinal);

    const dias = dataFinalMoment.diff(dataInicialMoment, 'days');

    return dias <= 7;
  };

}